import script from "./ItemsSidebar.vue?vue&type=script&lang=jsx"
export * from "./ItemsSidebar.vue?vue&type=script&lang=jsx"

import "./ItemsSidebar.vue?vue&type=style&index=0&id=a6048908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6048908"]])

export default __exports__